export default "__VITE_ASSET__C5N2txMn__"